import { DL_QUERY_STRINGS } from '../../../constants/dealerLocator.constants';
import useQueryParams from '../../../hooks/useQueryParams.effect';
import { TDealerSelectedFiltersState, TSelectedFilterOptions } from '../types/dealerLocatorLanding.types';

const useSelectedFiltersState = (
  initialState: TDealerSelectedFiltersState
): [TDealerSelectedFiltersState, (TDealerSelectedFiltersState) => void] => {
  const encodeFiltersData = (filterData: TSelectedFilterOptions): string => {
    const keys = Object.keys(filterData);
    const queryString = keys.map((key) => key + ':' + filterData[key]?.join(','))?.join(';');

    return queryString ?? '';
  };

  const [eqFilters, setEqFilters] = useQueryParams(
    DL_QUERY_STRINGS.EQUIPMENT_FILTERS,
    encodeFiltersData(initialState.equipmentSelectedOptions)
  );
  // const [seFilters, setSeFilters] = useQueryParams(
  const [, setSeFilters] = useQueryParams(DL_QUERY_STRINGS.SERVICES_FILTERS, encodeFiltersData(initialState.serviceSelectedOptions));

  const parseFiltersData = (queryString: string): TSelectedFilterOptions => {
    const propsArray = queryString?.split(';').map((prop) => prop?.split(':'));
    const filterObj = {};

    propsArray.forEach((prop) => {
      if (!prop[0] || prop[0] === '' || typeof prop[0] === 'undefined') {
        return;
      }
      filterObj[prop[0]] = prop[1]?.split(',');
    });

    return filterObj;
  };

  const setSelectedFilters = ({ equipmentSelectedOptions, serviceSelectedOptions }) => {
    setEqFilters(encodeFiltersData(equipmentSelectedOptions));
    setSeFilters(encodeFiltersData(serviceSelectedOptions));
  };

  const equipmentSelectedOptions = parseFiltersData(eqFilters);
  // Todo: Replace this code with line no. 47 for Services Ref US-446445
  // const serviceSelectedOptions = parseFiltersData(seFilters);
  // End Code comments US-446445
  const serviceSelectedOptions = parseFiltersData('');
  const selectedFilters = { equipmentSelectedOptions, serviceSelectedOptions };
  return [selectedFilters, setSelectedFilters];
};

export default useSelectedFiltersState;
